import React from "react";

function Canvas_Radial_Gradient() {
  return (
    <div>
      <h1>Canvas_Radial_Gradient Component</h1>
      <p>This is the Canvas Radial Gradient tutorial page content.</p>
    </div>
  );
}

export default Canvas_Radial_Gradient;
